import type { SVGProps } from 'react';
const SvgPersonAddDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#person_add_disabled_svg__a)">
      <path d="M15 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM23 20v-2c0-2.3-4.1-3.7-6.9-3.9l6 5.9h.9Zm-11.6-5.5C9.2 15.1 7 16.3 7 18v2h9.9l4 4 1.3-1.3-21-20.9L0 3.1l4 4V10H1v2h3v3h2v-3h2.9l2.5 2.5ZM6 10v-.9l.9.9H6Z" />
    </g>
    <defs>
      <clipPath id="person_add_disabled_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPersonAddDisabled;
